import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextAvatarDirective } from './text-avatar/text-avatar.directive';
import { MaskDirective } from './mask/mask.directive';
import { DisableControlDirective } from './disableControl/disable-control.directive';
import { HasRoleDirective } from './has-role/has-role.directive';

@NgModule({
  declarations: [
    TextAvatarDirective,
    MaskDirective,
    DisableControlDirective,
    HasRoleDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TextAvatarDirective,
    MaskDirective,
    DisableControlDirective,
    HasRoleDirective,
  ]
})
export class SharedDirectivesModule { }
